import { useRef, useState } from 'react';
import { useOtpMutation } from '../../../../store/api-slices';
import { TURNSTILE_ENABLED, TURNSTILE_VERIFICATION_TOKEN_HEADER } from '../../../../components-library/auth/OtpFlow';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import collect from 'collect.js';

const useOtpFlow = () => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Modals:Login:useOtpFlow' });
  const [requestOtp, otpResult] = useOtpMutation();
  const [loading, setLoading] = useState<boolean>(false);
  const tokenRef = useRef<string>('');

  const send = async (args: Parameters<typeof requestOtp>[0]) => {
    if (!tokenRef.current && TURNSTILE_ENABLED) {
      toast.error(t('feedback.token_required'));
      return Promise.reject(t('feedback.token_required'));
    }
    setLoading(true);
    const request = await requestOtp({
      ...args,
      headers: { [TURNSTILE_VERIFICATION_TOKEN_HEADER]: tokenRef.current },
    });
    setLoading(false);
    switch ((request as any)?.error?.status) {
      case 422:
        collect((request as any).error.data.response.data.errors)
          .values()
          .each((error: string) => toast.error(error));
        break;
      case 429:
        toast.error(t('feedback.frequent_requests'));
        break;
    }
  };

  const resend = async () => {
    setLoading(true);
    await requestOtp({
      ...otpResult.originalArgs!,
      headers: { [TURNSTILE_VERIFICATION_TOKEN_HEADER]: tokenRef.current },
    });
    setLoading(false);
  };

  return {
    otpResult,
    loading,
    send,
    resend,
    attachToken: (token: string) => {
      tokenRef.current = token;
    },
    hasTurnstile: TURNSTILE_ENABLED,
  };
};

export default useOtpFlow;
